import { Component, OnInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
    selector: 'app-chart-child',
    templateUrl: './charts.component.html',
    styleUrls: ['./charts.component.scss']
})
export class ChildChartComponent implements OnInit {
    @Input() chart: any;
    @Input() id: any;
    @Input() dbData: any;

    labelArray: string[] = [];
    valuesArray: number[] = [];
    backgroundColorArray: string[] = [];
    borderColorArray: string[] = [];

    constructor() { }

    ngOnInit() {
    }
    ngAfterViewInit() {
        if (this.dbData && this.chart) {
            for (let i = 0; i < this.dbData.length; i++) {
                if (this.dbData[i].id == this.chart) {
                    let labelSplit = this.dbData[i].label.split(' | ');
                    let valueSplit = [];
                    if (this.dbData[i].value.indexOf('<Num>') !== -1) {
                        this.dbData[i].value = this.dbData[i].value.replace('<Num>', '');
                        this.dbData[i].value = this.dbData[i].value.replace('<Num>', '');
                        this.dbData[i].value = this.dbData[i].value.replace('</Num>', ',');
                        this.dbData[i].value = this.dbData[i].value.replace('</Num>', '');
                        valueSplit = this.dbData[i].value.split(',');
                    } else {
                        valueSplit = this.dbData[i].value.split(',');
                    }
                    this.labelArray = [];
                    this.valuesArray = [];
                    for (let x = 0; x < labelSplit.length; x++) {
                        this.labelArray.push(labelSplit[x]);
                    }

                    for (let x = 0; x < valueSplit.length; x++) {
                        if (valueSplit[x].length > 0) {
                            this.valuesArray.push(Math.round(valueSplit[x]));
                        }
                    }

                    if (this.dbData[i].name == 'SkyTracker') {
                        this.backgroundColorArray = ['rgba(54, 162, 235, 0.2)', 'rgba(120, 147, 161, 0.2)', 'rgba(230, 245, 255, 0.2)'];
                        this.borderColorArray = ['rgba(54, 162, 235, 1)', 'rgba(120, 147, 161, 1)', 'rgba(230, 245, 255, 1)'];
                    } else {
                        this.backgroundColorArray = ['rgba(54, 162, 235, 0.2)', 'rgba(230, 245, 255, 0.2)'];
                        this.borderColorArray = ['rgba(54, 162, 235, 1)', 'rgba(230, 245, 255, 1)'];
                    }

                    this.addchart((i + 1).toString(), this.labelArray, this.valuesArray, this.backgroundColorArray, this.borderColorArray);
                }
            }
        }
    }

    addchart(chartid: string, labelArray: string[], dataArray: number[], backgroundArray: string[], borderArray: string[]) {
        var canvas = <HTMLCanvasElement>document.getElementById(chartid);
        var mychart = new Chart(canvas, {
            type: 'doughnut',
            data: {
                labels: labelArray,
                datasets: [{
                    data: dataArray,
                    backgroundColor: backgroundArray,
                    borderColor: borderArray
                }]
            },
            options: {
                responsive: true,
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            }
        });
    }

}